export default class CustomSelect {
    constructor(model) {
        this.model = model;
        this.generateCustomSelect(this.closeAllSelect);
        document.addEventListener("click", this.closeAllSelect);
    }

    generateCustomSelect = (closeAllSelect) => {
        let x, i, j, l, ll, selElmnt, a, b, c;
        x = document.getElementsByClassName("custom-select");
        l = x.length;

        for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            ll = selElmnt.length;

            // Create the DIV for the selected item
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");

            // Check if the selected option exists before accessing it
            if (selElmnt.selectedIndex >= 0) {
                let selectedOption = selElmnt.options[selElmnt.selectedIndex];
                let selectedIcon = selectedOption?.hasAttribute('data-icon');

                if (selectedIcon) {
                    a.innerHTML = `<span class="material-icons-outlined">${selectedOption.getAttribute('data-icon')}</span>`;
                } else {
                    a.innerHTML = selectedOption.innerHTML;
                }

                a.setAttribute("data-value", selectedOption.value);
            } else {
                a.innerHTML = ''; // If no option is selected
            }

            x[i].appendChild(a);

            // Create the DIV for the dropdown options
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");

            for (j = 0; j < ll; j++) {
                c = document.createElement("DIV");
                let option = selElmnt.options[j];
                c.setAttribute("data-value", option.value);

                // Check if the option should render as a material icon or text
                if (option.hasAttribute('data-icon')) {
                    c.innerHTML = `<span class="material-icons-outlined">${option.getAttribute('data-icon')}</span>`;
                } else {
                    c.innerHTML = option.innerHTML;
                }

                // Add click event to handle selection
                c.addEventListener("click", function (e) {
                    let y, i, k, s, h, sl, yl;
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    sl = s.length;
                    h = this.parentNode.previousSibling;

                    for (i = 0; i < sl; i++) {
                        if (s.options[i].value == this.getAttribute('data-value')) {
                            s.selectedIndex = i;
                            if (s.options[i].hasAttribute('data-icon')) {
                                h.innerHTML = `<span class="material-icons-outlined">${s.options[i].getAttribute('data-icon')}</span>`;
                            } else {
                                h.innerHTML = this.innerHTML;
                            }
                            y = this.parentNode.getElementsByClassName("same-as-selected");
                            yl = y.length;
                            for (k = 0; k < yl; k++) {
                                y[k].removeAttribute("class");
                            }
                            this.setAttribute("class", "same-as-selected");
                        }
                    }
                    h.click();

                    if (s.classList.contains('dispatchChange')) {
                        s.dispatchEvent(new Event('change'));
                    }
                });

                b.appendChild(c);
            }
            x[i].appendChild(b);

            a.addEventListener("click", function (e) {
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
            });
        }
    }

    closeAllSelect = (elmnt) => {
        let x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < xl; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    refresh = () => {
        $(".select-selected").remove();
        $(".select-items").remove();
        this.generateCustomSelect(this.closeAllSelect);
    }

    setValue = (selectorContainer, val, txt) => {
        $(`${selectorContainer} select`).val(val);
        $(`${selectorContainer} .select-selected`).attr('data-value', val);
        $(`${selectorContainer} .select-selected`).text(txt);
    }
}
